export const requestJson = async (url, options = {}) => {
  const { method = "GET", headers = {}, body } = options;
  const mergedHeaders = { ...headers };
  const init = { method, headers: mergedHeaders };

  if (body !== undefined) {
    init.body = JSON.stringify(body);
    if (!mergedHeaders["Content-Type"]) {
      mergedHeaders["Content-Type"] = "application/json";
    }
  }

  const response = await fetch(url, init);
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  return { data, status: response.status, ok: response.ok };
};

export const requestForm = async (url, options = {}) => {
  const { method = "POST", headers = {}, body } = options;
  const mergedHeaders = { ...headers };
  delete mergedHeaders["Content-Type"];

  const response = await fetch(url, {
    method,
    headers: mergedHeaders,
    body,
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  return { data, status: response.status, ok: response.ok };
};
